/**
 * AccountingViewRoute — skin-aware switcher for /accounting.
 * Cockpit gets a full structural rewrite (AccountingViewCockpit).
 */
import { useUISkin } from "@/data/UISkinContext";
import AccountingView from "./AccountingView";
import AccountingViewCockpit from "./AccountingViewCockpit";

export default function AccountingViewRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <AccountingViewCockpit />;
  return <AccountingView />;
}
